import { FC } from "react";
import { Socket } from "socket.io-client";
import { roomDataType } from "./Cardate";
import React from "react";

export const RoomHeader: FC<{ socket: Socket, roomData: roomDataType | null }> = ({ socket, roomData }) => {
  if (!roomData) return <></>;
  return <section id="game-header" className="flex bg-white/30 rounded-lg border border-white/50 p-2 md:p-3 mb-2 justify-between items-center text-slate-700">
    <div id="room-id">ID:{roomData.roomID}</div>
    <div id="room-name" className="font-bold hidden md:block">{roomData.roomName}</div>
    <div id="room-mp">{roomData.matchPoint}本先取</div>
    <button
      onClick={() => { socket?.emit("exit_room"); }}
      className="w-[4em] flex items-center justify-center bg-red-600 text-white rounded-lg border-none cursor-pointer transition-all duration-300 text-base hover:bg-red-400 hover:shadow-[0_4px_12px_rgba(212,165,116,0.3)]"
    >
      退出
    </button>
  </section>;
}
